import { createLogger } from './logger.ts'

export type Unsubscribe = () => void

export type Disposable = (() => void) | { dispose(): void }

export interface Disposables {
  add(disposable: Disposable): void
  /** Disposes everything in reverse order of adding. Safe to call more than once. */
  dispose(): void
}

const log = createLogger('disposables')

export function createDisposables(): Disposables {
  let items: Disposable[] = []

  return {
    add(disposable) {
      items.push(disposable)
    },
    dispose() {
      const pending = items.reverse()
      items = []
      // One failing cleanup must not leak everything added before it.
      for (const item of pending) {
        try {
          if (typeof item === 'function') item()
          else item.dispose()
        } catch (error) {
          log.error('Dispose failed', error)
        }
      }
    },
  }
}
